import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PDFDownloadLink } from '@react-pdf/renderer';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Button,
  LinearProgress,
  Box,
} from '@mui/material';

import hgsdLogo from '../black-textHGSDlogo400px.png';
import ftBendLogo from '../fbsd_logo_clr_rgb.png';
import SummaryReport from './SummaryReport';
import ReportBuilder from './ReportBuilder';

const styles = {
  title: {
    flexGrow: 1,
    color: '#fff',
    textDecorationLine: 'none',
  },
  logo: {
    width: 40,
    height: 40,
  },
  progressBar: {
    color: 'white',
    backgroundColor: 'red',
    width: 75,
  },
  downloadButton: {
    color: '#fff',
    textDecorationLine: 'none',
  },
};

export default function MyAppBar(props) {
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const [progress, setProgress] = useState(0);
  const [buttonClick, setButtonClick] = useState(false);

  const handleReportClick = async () => {
    setButtonClick(true);

    const dataEmitter = ReportBuilder.buildReport({
      permittees: props.permittees,
      year: props.year,
      month: props.month,
    });
    dataEmitter.on('Progress', (percentage) => {
      console.log(`${percentage}%`);
      setProgress(percentage);
    });
    dataEmitter.on('Done', (reportData) => {
      console.log('Done.');
      setData(reportData);
      setShow(true);
    });
  };

  const handleDownloadReport = (e) => {
    console.log('handleDownloadReport');
    console.log(e);
    setButtonClick(false);
    setShow(false);
    return true;
  };

  return (
    <div sx={styles.root}>
      <AppBar position='static'>
        <Toolbar>
          <IconButton edge='start'>
            {/* <img
              sx={styles.logo}
              src={window.config.client === 'FT-BEND' ? ftBendLogo : hgsdLogo}
              alt=''
            /> */}
            <Box
              component='img'
              sx={styles.logo}
              src={window.config.client === 'FT-BEND' ? ftBendLogo : hgsdLogo}
              alt=''
            />
          </IconButton>
          <Typography variant='h6' sx={styles.title} component={Link} to={'/'}>
            {props.title}
          </Typography>
          {!show && props.permittees && props.permittees.length > 0 && (
            <div>
              <div>
                <Button color='inherit' onClick={handleReportClick}>
                  Report
                </Button>
              </div>
              {buttonClick && (
                <div>
                  <Box display='flex' alignItems='center'>
                    <Box width='100%' mr={1}>
                      <LinearProgress variant='determinate' value={progress} />
                    </Box>
                    <Box minWidth={35}>
                      <Typography
                        variant='body2'
                        color='textSecondary'
                      >{`${Math.round(progress)}%`}</Typography>
                    </Box>
                  </Box>
                </div>
              )}
            </div>
          )}
          {show && (
            <PDFDownloadLink
              document={
                <SummaryReport
                  // permittees={data}
                  data={data}
                  year={props.year}
                  month={props.month}
                />
              }
              // fileName='testReport.pdf'
              fileName={`BoardbookReport(${props.year}-${props.month})`}
            >
              {({ blob, url, loading, error }) =>
                loading ? (
                  'Building Report...'
                ) : (
                  <Button sx={styles.downloadButton}>Download Report</Button>

                  // 'Download Report'
                  // <div>Download Report</div>
                )
              }
            </PDFDownloadLink>
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
}

/* <PDFDownloadLink
  document={<SummaryReport permittees={props.permittees} />}
  fileName='testReport.pdf'
>
  Report
</PDFDownloadLink> */
